var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAge18(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_23_56)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.5 47C36.9264 47 47 36.9264 47 24.5C47 12.0736 36.9264 2 24.5 2C12.0736 2 2 12.0736 2 24.5C2 36.9264 12.0736 47 24.5 47Z",
    stroke: "#080A52",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2248 20.1497L8.2998 22.5497L6.7998 20.8247L11.4498 17.0747H13.7748V31.9247H11.2248V20.1497Z",
    fill: "#080A52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7999 20.7497C27.7999 22.4747 26.8249 23.6747 25.4749 24.1247V24.1997C27.0499 24.5747 28.2499 25.9997 28.2499 27.7997C28.2499 30.7247 25.9249 32.3747 23.0749 32.3747C20.2249 32.3747 17.8999 30.7247 17.8999 27.7997C17.8999 25.8497 19.2499 24.5747 20.6749 24.1997V24.1247C19.3249 23.6747 18.3499 22.6247 18.3499 20.8997C18.3499 18.3497 20.4499 16.7747 23.0749 16.7747C25.6999 16.6997 27.7999 18.1997 27.7999 20.7497ZM20.5249 27.7247C20.5249 29.2997 21.6499 30.1997 23.0749 30.1997C24.4999 30.1997 25.6249 29.2997 25.6249 27.7247C25.6249 26.2247 24.4999 25.1747 23.0749 25.1747C21.6499 25.1747 20.5249 26.2247 20.5249 27.7247ZM20.9749 20.8997C20.9749 22.0997 21.7999 23.0747 23.1499 23.0747C24.3499 23.0747 25.3249 22.0997 25.3249 20.8997C25.3249 19.6247 24.2749 18.7997 23.1499 18.7997C21.8749 18.7997 20.9749 19.5497 20.9749 20.8997Z",
    fill: "#080A52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.4498 24.4996V19.8496H37.6248V24.4996H42.2748V26.6746H37.6248V31.2496H35.4498V26.5996H30.7998V24.4996H35.4498Z",
    fill: "#080A52"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_23_56"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 49,
    height: 49,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAge18);
export default __webpack_public_path__ + "static/media/age-18.758e7ca12fd03a12bbf3c7c9fea77606.svg";
export { ForwardRef as ReactComponent };